(function () {
    'use strict';
    const DEBUG = false;
    const log = (...a) => { if (DEBUG) console.log(...a); };
    const err = (...a) => { if (DEBUG) console.error(...a); };

    const COMPANY_ID = "RU2ww8";
    const REVISION = "2025-07-15";
    const EMAIL_MARKETING_LIST_ID = "UwUC7Z";
    const ENDPOINT = "https://a.klaviyo.com/client/profiles";
    const isEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

    function subscribeToEmailMarketing(email, listId) {
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: "SUBSCRIBED"
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId || EMAIL_MARKETING_LIST_ID
              }
            }
          }
        }
      };

      const url = new URL("https://a.klaviyo.com/client/subscriptions/");
      url.searchParams.set("company_id", COMPANY_ID);

      return fetch(url.toString(), {
        method: "POST",
        headers: {
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          revision: REVISION
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) {
          throw new Error(`Marketing subscription failed (${response.status})`);
        }
      });
    }

    function handleWaitlist(form, evt) {
        if (evt) evt.preventDefault();
        const waitlistId = form.getAttribute("waitlist-id") || form.dataset.waitlistId || "";
        const emailInput = form.querySelector("#waitlist-email, input[type='email']");
        const email = (emailInput?.value || "").trim();

      if (!email || !isEmail(email)) {
        showMessage(form, window.klaviyoStrings?.invalidEmail || "Please enter a valid email", "error", emailInput);
        emailInput?.focus();
        return;
      }

      if (!waitlistId) {
        console.error("Missing waitlist-id on .waitlist-form");
        showMessage(form, window.klaviyoStrings?.waitlistError || "Something went wrong. Please try again.", "error");
        return;
      }

      // Staging (sections/main-product.liquid sets the flag): no request to the production Klaviyo
      // account, the form answers as it does on live so the sign-up can be tested. The Bronze Filter
      // early-access list (T3UXLC) is the exception: the email joins that list for real, without the
      // back-in-stock request (staging variant ids are not in the live Klaviyo catalog).
      if (window.hbKlaviyoDryRun) {
        const dryRunForm = form.querySelector("form");
        const answer = () => {
          showMessage(form, window.klaviyoStrings?.waitlistSuccess || "Thanks, love! We'll send you an email as soon as it's live.", "success");
          if (dryRunForm) dryRunForm.reset();
        };
        if (form.dataset.klaviyoListId === "T3UXLC") {
          subscribeToEmailMarketing(email, form.dataset.klaviyoListId)
            .then(answer)
            .catch(function (e) {
              err("Klaviyo early-access subscription failed on staging.", e);
              showMessage(form, window.klaviyoStrings?.waitlistError || "Something went wrong. Please try again.", "error");
            });
          return;
        }
        answer();
        return;
      }

        // A product page can name its own list (buy buttons block "Waitlist Klaviyo list", for example
        // a launch's early-access list); otherwise sign-ups join the main newsletter list. Joining a
        // named list is the point of the form, so a failed subscription there shows an error and keeps
        // the email; the main newsletter subscription stays best effort, as before.
        const namedList = Boolean(form.dataset.klaviyoListId);
        subscribeToEmailMarketing(email, form.dataset.klaviyoListId)
        .then(function () { return true; }, function (e) {
          err("Klaviyo marketing subscription request failed before waitlist submit.", e);
          return false;
        })
        .then(function (subscribed) {
          if (namedList && !subscribed) {
            showMessage(form, window.klaviyoStrings?.waitlistError || "Something went wrong. Please try again.", "error");
            return;
          }
          const payload = { data: { type: "profile", attributes: { email, properties: { waitlistID: waitlistId } } } };
          const url = new URL(ENDPOINT); url.searchParams.set("company_id", COMPANY_ID);

          fetch(url.toString(), {
            method: "POST",
            headers: { accept: "application/vnd.api+json", "content-type": "application/vnd.api+json", revision: REVISION },
            body: JSON.stringify(payload)
          })
          .then(async res => {
            const text = await res.text().catch(() => "");
            if (res.status === 202 || res.ok) {
              showMessage(form, window.klaviyoStrings?.waitlistSuccess || "Thanks, love! We'll send you an email as soon as it's live.", "success");
              const actualForm = form.querySelector("form");
              if (actualForm) {
                actualForm.reset();
              }
            } else {
              console.error("Klaviyo waitlist failed");
              showMessage(form, window.klaviyoStrings?.waitlistError || "Something went wrong. Please try again.", "error");
            }
          })
          .catch(e => {
            console.error("Klaviyo request error");
            showMessage(form, window.klaviyoStrings?.waitlistError || "Something went wrong. Please try again.", "error");
          });
        });
    }

    document.addEventListener("submit", e => {
        const form = e.target.closest(".waitlist-form");
        if (form) handleWaitlist(form, e);
    });

    document.addEventListener("click", e => {
        const btn = e.target.closest(".notify-me-btn");
        if (!btn) return;
        const form = btn.closest(".waitlist-form");
        if (form) handleWaitlist(form, e);
    });

    let messageIdSeq = 0;

    // invalidInput is passed only for a bad email, so server errors do not mark a valid address as invalid.
    function showMessage(form, message, type, invalidInput = null) {
      // Find the message div
      const messageDiv = form.parentNode.querySelector(".waitlist-message");
      if (!messageDiv) {
        return;
      }

      // Clear any existing content
      messageDiv.innerHTML = "";
      messageDiv.className = "waitlist-message";

      // Set message content
      messageDiv.textContent = message;

      // Apply styling based on type
      if (type === "error") {
        messageDiv.style.color = "#c00";
        messageDiv.style.fontWeight = "400";
        messageDiv.classList.add("error-message");
      } else if (type === "success") {
        messageDiv.style.color = "#eb3986";
        messageDiv.style.fontWeight = "bold";
        messageDiv.classList.add("success-message");
      }

      // Common styling
      messageDiv.style.fontSize = "13px";
      messageDiv.style.padding = "8px";
      messageDiv.style.display = "block";

      const input = invalidInput || form.querySelector("input[type='email']");
      if (input) {
        if (invalidInput) {
          if (!messageDiv.id) messageDiv.id = "hb-waitlist-message-" + ++messageIdSeq;
          input.setAttribute("aria-invalid", "true");
          input.setAttribute("aria-describedby", messageDiv.id);
        } else {
          input.removeAttribute("aria-invalid");
        }
      }
    }
})();
